"use client";

import { convexClient } from "@convex-dev/better-auth/client/plugins";
import { genericOAuthClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

const baseURL =
	typeof window !== "undefined"
		? `${window.location.origin}/api/auth`
		: (process.env.NEXT_PUBLIC_CONVEX_SITE_URL ?? "http://127.0.0.1:3211");

export const authClient = createAuthClient({
	baseURL,
	plugins: [convexClient(), genericOAuthClient()],
});

export type AuthClient = typeof authClient;
